import request from "@/utils/request";

/**
 * 查询配置列表
 * @param {Object} data
 * @param {string} data.businessKey - 业务标识
 * @param {string[]} data.configKeyList - 配置标识数组（多选）
 */
export function queryConfig(data) {
  return request({
    url: "/app/config/queryConfig",
    method: "post",
    data,
  });
}
